import { DEFAULT_LOCALE } from 'localization/constants/configEnums';
import { getRouterLocale } from 'shared/utils/getRouterLocale';

export const getRedirectionPath = (pathWithoutLocale: string, _locale?: string) => {
  const locale = (_locale || getRouterLocale()) as string;

  if (!locale || locale === DEFAULT_LOCALE) {
    return pathWithoutLocale;
  }

  return `/${locale}${pathWithoutLocale}`;
};
